import { mapState } from 'vuex'
import CrudTable from '@/lib/uncrudtable/components/CrudTable'
import CustomViewDialog from '@/apps/core/components/CustomViewDialog/CustomViewDialog.vue'
import { BASE_URL } from '@/variables'

export default {
  name: 'EndorsementsTable',
  components: {
    CrudTable,
    CustomViewDialog
  },
  props: {
    'title': {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      agreementId: this.$route.params.id,
      storeModule: 'endorsements',
      options: {
        context: {
          serverUrl: BASE_URL,
          reload: true,
          agreementId: this.$route.params.id
        }
      },
      showEndorsementDetailModal: false,
      currentEndorsementDetail: {},
      editingMode: false
    }
  },
  computed: {
    ...mapState('endorsements', ['currentItem']),
    ...mapState({
      crudTableConfig: function (state) { return state[this.storeModule].crudTableConfig }
    }),

    getLinkAttributes () {
      const linkAttributes = {}
      let value = this.crudTableConfig.headers?.length > 0 ? this.crudTableConfig.headers[0].value : ''
      linkAttributes['path'] = `item.${value}`
      linkAttributes['name'] = value
      return linkAttributes
    },
    customViewActions () {
      return [{ label: this.$t('general.save'), icon: 'fa-save', color: 'primary', event: 'save', validate: true }]
    }
  },
  beforeDestroy () {
    this.$store.commit(`${this.storeModule}/clearItems`)
  },
  watch: {
    showEndorsementDetailModal (val) {
      if (!val) {
        this.$store.commit(`${this.storeModule}/resetCurrent`)
        if (this.editingMode) this.editingMode = false
      }
    }
  },
  methods: {
    onCreateEndorsement () {
      this.showEndorsementDetailModal = true
    },
    async onEditEndorsement (endorsementId) {
      this.showEndorsementDetailModal = true
      this.editingMode = true
      try {
        await this.$store.dispatch(`${this.storeModule}/getEndorsement`, endorsementId)
        this.currentEndorsementDetail = { ...this.currentItem }
      } catch (e) {
        console.error(e)
      }
    },
    async saveForm () {
      this.loading = true
      try {
        if (this.editingMode) {
          await this.$store.dispatch(`${this.storeModule}/putFormItem`, this.currentEndorsementDetail)
        } else {
          const newItem = { ...this.currentEndorsementDetail, agreement: this.agreementId }
          await this.$store.dispatch(`${this.storeModule}/postFormItem`, newItem)
        }
        this.currentEndorsementDetail = {}
        this.showEndorsementDetailModal = false
        await this.$store.dispatch(`${this.storeModule}/reloadItemList`)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
